import { FC } from "react";

type IProps = {
  width?: number | string;
  height?: number | string;
  stroke?: string;
  strokeWidth?: number | string;
  className?: string;
};

const ExternalLinkIcon: FC<IProps> = ({
  width = 16,
  height = 16,
  stroke = "currentColor",
  strokeWidth = "2.5",
  className = "ext-link-icon",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
};

export default ExternalLinkIcon;
